module.exports = __webpack_public_path__ + "img/product4p.fe210291.png";